import { useEffect, useState } from "react";
import { getSettings } from "context/actions/settings";

// ============================================================
// Нүүр хуудасны бүх ЗАСВАРЛАЖ БОЛОХ текстийн өгөгдмөл утга + бүлэг.
// Энэ бол "эх схем" — admin/settings хуудас үүн дээр тулгуурлан талбаруудаа үзүүлнэ,
// нийтийн компонентууд DB-д утга байхгүй үед эдгээр өгөгдмөлийг ашиглана.
// ============================================================
export const SETTINGS_SCHEMA = [
  {
    group: "hero",
    label: "Нүүр (Hero) хэсэг",
    fields: [
      { key: "hero.title", label: "Гарчиг", default: "Оргил карго" },
      {
        key: "hero.subtitle",
        label: "Дэд гарчиг",
        multiline: true,
        default:
          "Бид Эрээн – Говь-Алтай чиглэлд таны ачааг хурдан шуурхай, найдвартайгаар тээвэрлэнэ.",
      },
      { key: "hero.badge1", label: "Шошго 1", default: "Найдвартай" },
      { key: "hero.badge2", label: "Шошго 2", default: "Хурдан" },
      { key: "hero.badge3", label: "Шошго 3", default: "Туршлагатай" },
      {
        key: "hero.searchPlaceholder",
        label: "Хайлтын талбарын бичвэр",
        default: "Утас дугаар болон Трак код оруулна уу",
      },
    ],
  },
  {
    group: "services",
    label: "Үйлчилгээ хэсэг",
    fields: [
      { key: "services.title", label: "Гарчиг", default: "Манай үйлчилгээ" },
      {
        key: "services.subtitle",
        label: "Дэд гарчиг",
        multiline: true,
        default:
          "Эрээн - Говь-Алтай чиглэлд таны ачааг хурдан шуурхай, найдвартай хүргэнэ.",
      },
      {
        key: "services.warning",
        label: "Анхаарах зүйлс",
        multiline: true,
        default:
          "Амархан хагарч гэмтэх, хөлдөх, түргэн муудах болон шингэн зүйлс, ургамал, амьтан, тэсэрч дэлбэрэх аюултай бараа болон МУ-ын хилээр оруулахыг хориглосон бараа хүлээж авахгүй.",
      },
      {
        key: "services.facebookUrl",
        label: "Facebook group холбоос",
        // Хоосон бол Facebook холбоос сайт дээр харагдахгүй (админ → Сайтын тохиргооноос оруулна)
        default: "",
      },
      {
        key: "services.facebookLabel",
        label: "Facebook бичвэр",
        default: "Оргил карго Facebook group",
      },
    ],
  },
  {
    group: "stats",
    label: "Амжилт (Stats) хэсэг",
    fields: [
      { key: "stats.title", label: "Гарчиг", default: "Бидний Амжилт" },
      {
        key: "stats.subtitle",
        label: "Дэд гарчиг",
        default: "Олон жилийн туршлага, найдвартай үйлчилгээ",
      },
      { key: "stats.value1", label: "Үзүүлэлт 1 - тоо", default: "10,000+" },
      { key: "stats.label1", label: "Үзүүлэлт 1 - нэр", default: "Идэвхтэй хэрэглэгчид" },
      { key: "stats.value2", label: "Үзүүлэлт 2 - тоо", default: "900,000+" },
      { key: "stats.label2", label: "Үзүүлэлт 2 - нэр", default: "Ачаа" },
      { key: "stats.value3", label: "Үзүүлэлт 3 - тоо", default: "5" },
      { key: "stats.label3", label: "Үзүүлэлт 3 - нэр", default: "Салбар" },
      { key: "stats.value4", label: "Үзүүлэлт 4 - тоо", default: "100%" },
      { key: "stats.label4", label: "Үзүүлэлт 4 - нэр", default: "Үнэлгээ" },
    ],
  },
  {
    group: "branchSection",
    label: "Салбарууд хэсгийн гарчиг",
    fields: [
      { key: "branch.title", label: "Гарчиг", default: "Салбарууд" },
      {
        key: "branch.subtitle",
        label: "Дэд гарчиг",
        default: "Ачаа хүлээлгэж өгөх салбаруудын мэдээлэл",
      },
    ],
  },
  {
    group: "footer",
    label: "Хөл (Footer) хэсэг",
    fields: [
      { key: "footer.servicesTitle", label: "Үйлчилгээний гарчиг", default: "Манай үйлчилгээ" },
      { key: "footer.service1", label: "Үйлчилгээ 1", default: "БНХАУ-ын бүх хот мужуудаас шуурхай тээвэр" },
      { key: "footer.service2", label: "Үйлчилгээ 2", default: "Хятадын онлайн шопуудаас захиалга хийх сургалт" },
      { key: "footer.hoursTitle", label: "Цагийн гарчиг", default: "Ажиллах цагийн хуваарь" },
      { key: "footer.hours", label: "Цагийн хуваарь", multiline: true, default: "Өдөр бүр: 09:00-22:00" },
      { key: "footer.contactTitle", label: "Холбоо барих гарчиг", default: "Холбоо барих" },
      // Хоосон бол утас харагдахгүй (админ → Сайтын тохиргооноос оруулна)
      { key: "footer.phone", label: "Утас (олон бол таслалаар тусгаарлана)", default: "" },
      { key: "footer.copyright", label: "Зохиогчийн эрх", default: "©2025 Зохиогчийн эрх хуулиар хамгаалагдсан." },
    ],
  },
];

// Бүх өгөгдмөл утгыг нэг map болгож бэлдэнэ
export const SETTINGS_DEFAULTS = SETTINGS_SCHEMA.reduce((acc, g) => {
  g.fields.forEach((f) => {
    acc[f.key] = f.default;
  });
  return acc;
}, {});

// "99112233, 88112233" гэх мэт таслал/цэг таслалаар тусгаарласан утсыг массив болгоно
export const splitPhones = (value) =>
  String(value || "")
    .split(/[,;\/\n]/)
    .map((p) => p.trim())
    .filter(Boolean);

// Модул-түвшний кэш — олон компонент нэг л удаа татна
let _cache = null;
let _inflight = null;

export const fetchSiteSettings = async (force = false) => {
  if (_cache && !force) return _cache;
  if (_inflight) return _inflight;
  _inflight = (async () => {
    const res = await getSettings();
    const map = res?.status === "success" ? res.data?.map || {} : {};
    _cache = { ...SETTINGS_DEFAULTS, ...map };
    _inflight = null;
    return _cache;
  })();
  return _inflight;
};

export const clearSettingsCache = () => {
  _cache = null;
};

// React hook — get(key) аргаар утгад хандана
export default function useSiteSettings() {
  const [map, setMap] = useState(_cache || SETTINGS_DEFAULTS);

  useEffect(() => {
    let active = true;
    fetchSiteSettings().then((m) => {
      if (active) setMap(m);
    });
    return () => {
      active = false;
    };
  }, []);

  const get = (key, fallback = "") => (map && map[key] != null ? map[key] : (SETTINGS_DEFAULTS[key] ?? fallback));

  return { get, map };
}
